export default "__VITE_ASSET__DAXu$MTQ__"